module.exports = __webpack_public_path__ + "media/images/partner-13-e3a1ade2946f3ecb4aab3b01e562b0f7.png";